export default __webpack_public_path__ + "static/media/xpensityV1-lg-1.1a6c3c2b.webp";